import { render, staticRenderFns } from "./ReservationBuildingModal.vue?vue&type=template&id=dfd58524&"
import script from "./ReservationBuildingModal.vue?vue&type=script&lang=js&"
export * from "./ReservationBuildingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports